import template from './component.tpl.html';
import './controller';

/**
 * @ngdoc component
 * @name theme.festzelt-os.component:alPagination
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example <al-pagination></al-pagination>
 *
 */
angular
    .module('festzelt-os.theme.festzelt-os')
    .component('alPagination', {
        templateUrl: template,
        controllerAs: 'pagination',
        controller: 'AlPaginationCtrl',
        bindings: {
            store: '='
        }
    });



// WEBPACK FOOTER //
// ./src/app/theme/festzelt-os/components/al-pagination/component.js